export const getHoursSinceDate = (date: Date) => {
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  return diffInMs / (1000 * 60 * 60);
};
